import { Reducer } from "redux";
import { IUserState, UserActionTypes } from "./types";

const initialState: IUserState = {
  data: [],
  errors: undefined,
  loading: false,
};

const reducer: Reducer<IUserState> = (state = initialState, action) => {
  switch (action.type) {
    case UserActionTypes.FETCH_REQUEST: {
      return { ...state, loading: true };
    }
    case UserActionTypes.FETCH_SUCCESS: {
      return { ...state, loading: false, data: action.payload };
    }
    case UserActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    case UserActionTypes.SAVE_SUCCESS: {
      const index = state.data.findIndex((item) => item.id === action.payload.id);
      if (index === -1) {
        return {
          ...state,
          data: state.data.concat(action.payload),
        };
      }
      const updatedData = state.data.map((item, innerIndex) => {
        if (innerIndex !== index) {
          return item;
        }
        return {
          ...item,
          ...action.payload,
        };
      });
      return {
        ...state,
        data: updatedData,
      };
    }
    case UserActionTypes.PASSWORD_CHANGE_SUCCESS: {
      const index = state.data.findIndex((item) => item.id === action.payload.userId);
      if (index === -1) {
        return state;
      }
      const updatedData = state.data.map((item, innerIndex) => {
        if (innerIndex !== index) {
          return item;
        }
        return {
          ...item,
          password: action.payload.newPassword,
        };
      });
      return {
        ...state,
        data: updatedData,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as userReducer };
